export default "__VITE_ASSET__BLw6V4D9__"